import { ApiQueryAutocomplete } from "../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { TopicItemForMerchant, TopicType } from "../merchantSurveyTypes"
import { useFetchSurveyTopics } from "../hooks/useFetchSurveyTopics"

function areSurveysEqual(x: TopicItemForMerchant, y: TopicItemForMerchant) {
    return x.id === y.id
}

type SurveyTopicsSelectorProps = Readonly<{
    topicType: TopicType.GOOD_TOPICS | TopicType.BAD_TOPICS
    onSelectionChange: (selected: TopicItemForMerchant[], type: TopicType.GOOD_TOPICS | TopicType.BAD_TOPICS) => void
    initialSelectedTopics?: TopicItemForMerchant[]
}>

export const SurveyTopicsSelector = ({
    topicType,
    initialSelectedTopics,
    onSelectionChange,
}: SurveyTopicsSelectorProps) => {
    const { data, isLoading, isError } = useFetchSurveyTopics()
    const topicsTypeList = data ? data[topicType] : []

    return (
        <>
            <LocalizedStrict
                id={
                    topicType === TopicType.GOOD_TOPICS
                        ? "create-or-edit-merchant-survey-dialog-topics-good"
                        : "create-or-edit-merchant-survey-dialog-topics-bad"
                }
                attrs={{ label: true }}
            >
                <ApiQueryAutocomplete
                    multiple={true}
                    isLoading={isLoading}
                    isError={isError}
                    options={topicsTypeList || []}
                    getOptionLabel={(option) => option.value}
                    isOptionEqualToValue={areSurveysEqual}
                    value={initialSelectedTopics}
                    onChange={(event, value) => onSelectionChange(value, topicType)}
                />
            </LocalizedStrict>
        </>
    )
}
